/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import CustomPagination from "components/CustomPagination";
import { FaArrowDown, FaArrowUp, FaClock } from "react-icons/fa6";
import { IoHandRightSharp, IoTrash } from "react-icons/io5";
import ModalCommonConfirm from "components/dialogCommon/templates/modalCommonConfirm";
import ModalCommonOpt from "screens/roleta/components/modalOpt";
import { useRecepcaoAusencia } from "services/api/RoletaRecepcionista/put-ausencia";
import { useRemoverUsuario } from "services/api/RoletaRecepcionista/delete-usuario";
import { useMovimentarFila } from "services/api/RoletaRecepcionista/put-movimentar-fila";
import * as S from "./styles";
import * as IconsSVG from "../../../../../assets/iconsSVG";
import MaterialUI from "../../../../../material-UI";

interface ITabelaFilaProps {
  dataListarFila: any;
  refetchListarFila: () => void;
  palavraChave: string;
}

const TabelaFila = ({
  palavraChave,
  dataListarFila,
  refetchListarFila,
}: ITabelaFilaProps) => {
  const [page, setPage] = useState(1);

  const [isOpenMove, setIsOpenMove] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenReturn, setIsOpenReturn] = useState(false);
  const [isOpenAway, setIsOpenAway] = useState(false);
  const [isOpenBaterMao, setIsOpenBaterMao] = useState(false);

  const [idCorretorSistemaOrigem, setIdCorretorSistemaOrigem] = useState("");

  const [enumMove, setEnumMove] = useState("");

  const itemsPerPage = 8;

  const primeiro = dataListarFila?.fila[0];
  const restantes = dataListarFila?.fila?.slice(1);

  const totalPages = Math.ceil(restantes.length / itemsPerPage);

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageItems = restantes.slice(startIndex, endIndex);

  const fila = dataListarFila?.fila || [];

  useEffect(() => {
    setPage(1);
  }, [fila]);

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
  };

  const { mutate: mutateAusencia, isLoading: isLoadingAusencia } =
    useRecepcaoAusencia();

  const openAusencia = (idCorretorSistemaOrigem: string) => {
    setIsOpenAway(true);
    setIdCorretorSistemaOrigem(idCorretorSistemaOrigem);
  };

  const handleAusencia = (opcaoAusencia: string) => {
    mutateAusencia(
      {
        idRoletaCheckin: dataListarFila?.idRoletaCheckin,
        idCorretorSistemaOrigem,
        opcaoAusencia,
      },
      {
        onSuccess: () => {
          setIsOpenAway(false);
          refetchListarFila();
        },
      }
    );
  };

  const openReturn = (idCorretorSistemaOrigem: string) => {
    setIsOpenReturn(true);
    setIdCorretorSistemaOrigem(idCorretorSistemaOrigem);
  };

  const handleReturn = (opcaoAusencia: string) => {
    mutateAusencia(
      {
        idRoletaCheckin: dataListarFila?.idRoletaCheckin,
        idCorretorSistemaOrigem,
        opcaoAusencia,
      },
      {
        onSuccess: () => {
          setIsOpenReturn(false);
          refetchListarFila();
        },
      }
    );
  };

  const { mutate: mutateRemover, isLoading: isLoadingRemover } =
    useRemoverUsuario();

  const openDelete = (idCorretorSistemaOrigem: string) => {
    setIdCorretorSistemaOrigem(idCorretorSistemaOrigem);
    setIsOpenDelete(true);
  };

  const handleDelete = () => {
    mutateRemover(
      {
        idRoletaCheckin: dataListarFila?.idRoletaCheckin,
        idCorretorSistemaOrigem,
      },
      {
        onSuccess: () => {
          setIsOpenDelete(false);
          refetchListarFila();
        },
      }
    );
  };

  const openBaterMao = (idCorretorSistemaOrigem: string) => {
    setIsOpenBaterMao(true);
    setIdCorretorSistemaOrigem(idCorretorSistemaOrigem);
  };

  const { mutate: mutateMove, isLoading: isLoadingMove } = useMovimentarFila();

  const openMove = (idCorretorSistemaOrigem: string, enumMove: string) => {
    setIsOpenMove(true);
    setIdCorretorSistemaOrigem(idCorretorSistemaOrigem);
    setEnumMove(enumMove);
  };

  const startAtendimento = async (idCorretorSistemaOrigem: string) => {
    await setIdCorretorSistemaOrigem(idCorretorSistemaOrigem);
    mutateMove(
      {
        idRoletaCheckin: dataListarFila?.idRoletaCheckin,
        idCorretorSistemaOrigem,
        codigoOpcao: "0",
      },
      {
        onSuccess: () => {
          refetchListarFila();
        },
      }
    );
  };

  const handleMove = () => {
    mutateMove(
      {
        idRoletaCheckin: dataListarFila?.idRoletaCheckin,
        idCorretorSistemaOrigem,
        codigoOpcao: enumMove,
      },
      {
        onSuccess: () => {
          setIsOpenMove(false);
          refetchListarFila();
        },
      }
    );
  };

  if (dataListarFila?.fila?.length === 0)
    return (
      <div
        style={{
          color: "red",
          fontWeight: "bold",
          fontFamily: "Inter",
          fontSize: "20px",
          textAlign: "center",
          marginTop: "20px",
          marginBottom: "20px",
          width: "100%",
        }}
      >
        Corretor não encontrado!
      </div>
    );

  return (
    <S.Content>
      <S.HeaderGrid>
        <S.HeaderItem>
          {palavraChave === "" ||
          dataListarFila?.fila?.find((item: any) => item?.posicao === 1)
            ? "Vez no atendimento"
            : dataListarFila?.fila?.find((item: any) => item?.ativo === true)
            ? ""
            : "Removido da fila!"}
        </S.HeaderItem>
        <S.HeaderItem>
          {dataListarFila?.fila?.find((item: any) => item?.ativo === true)
            ? "Posição"
            : ""}
        </S.HeaderItem>
        <S.HeaderItem>
          {dataListarFila?.fila?.find((item: any) => item?.ativo === true)
            ? "Ações"
            : ""}
        </S.HeaderItem>
      </S.HeaderGrid>

      {/** PRIMEIRO DA FILA (FIXO) */}
      <S.HighlightRow>
        <S.HighlightCard>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                flex: 1,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                <S.CardTitle
                  textLine={!primeiro?.ativo}
                  color="#F43636"
                  width={primeiro?.infoAusencia ? "190px" : ""}
                >
                  {primeiro?.nomeCorretor}
                </S.CardTitle>
                <S.CardSubtitle
                  textLine={!primeiro?.ativo}
                  color="#F43636"
                  width={primeiro?.infoAusencia ? "190px" : ""}
                >
                  ({primeiro?.nomeEquipeCorretor})
                </S.CardSubtitle>
              </div>
              <S.HighlightSubtitle textLine={!primeiro?.ativo}>
                Imobiliária: {primeiro?.nomeEmpresaVendas}
              </S.HighlightSubtitle>
            </div>
            {primeiro?.infoAusencia ? (
              <S.SquareContainer>
                <S.Square>
                  <S.TextSquare>
                    <FaClock
                      color="#ffffff"
                      size={12}
                      style={{
                        marginRight: 8,
                        marginTop: 2,
                        marginLeft: 2,
                      }}
                    />
                    {primeiro?.infoAusencia?.mensagem}
                  </S.TextSquare>
                </S.Square>
              </S.SquareContainer>
            ) : null}
          </div>
        </S.HighlightCard>

        <S.HighlightActions>
          <S.IconsRow>
            {/* Posição 1 sempre */}
            {dataListarFila?.fila?.find((item: any) => item?.ativo === true) ? (
              <>
                <S.PositionNumberHighlight>
                  {primeiro?.posicao}
                </S.PositionNumberHighlight>
                <FaClock
                  onClick={() => {
                    if (primeiro?.ausente === true) {
                      openReturn(primeiro?.idCorretorSistemaOrigem);
                    } else openAusencia(primeiro?.idCorretorSistemaOrigem);
                  }}
                  color="#F18935"
                  size={20}
                  style={{ cursor: "pointer" }}
                />
                <IoHandRightSharp
                  onClick={() =>
                    openBaterMao(primeiro?.idCorretorSistemaOrigem)
                  }
                  color="#819DFF"
                  size={20}
                  style={{ cursor: "pointer" }}
                />
                <IoTrash
                  onClick={() => openDelete(primeiro?.idCorretorSistemaOrigem)}
                  color="#F43636"
                  size={20}
                  style={{ cursor: "pointer" }}
                />
              </>
            ) : null}
          </S.IconsRow>
          {palavraChave === "" ||
          dataListarFila?.fila?.find((item: any) => item?.posicao === 1) ? (
            <S.ButtonIniciar
              onClick={() =>
                startAtendimento(primeiro?.idCorretorSistemaOrigem)
              }
              disabled={isLoadingMove}
            >
              {isLoadingMove ? (
                <MaterialUI.CircularProgress size={20} color="inherit" />
              ) : (
                "Iniciar atendimento"
              )}
            </S.ButtonIniciar>
          ) : null}
        </S.HighlightActions>
      </S.HighlightRow>

      <S.Row style={{ gap: 32 }}>
        <S.Divider />
      </S.Row>

      {/** LISTA PAGINADA */}
      <S.ListContainer>
        {currentPageItems.map((item: any, index: number) => {
          const globalIndex = (page - 1) * itemsPerPage + index;
          const isLastItem =
            globalIndex ===
            restantes.filter((item: any) => item?.ativo).length - 1;

          return (
            <S.Row key={item.id}>
              <S.Card>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        gap: 4,
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <S.CardTitle width="12vw" textLine={!item?.ativo}>
                        {item?.nomeCorretor}
                      </S.CardTitle>
                      <S.CardSubtitle width="12vw" textLine={!item?.ativo}>
                        ({item?.nomeEquipeCorretor})
                      </S.CardSubtitle>
                    </div>
                    <S.CardSubtitle textLine={!item?.ativo}>
                      Imobiliária: {item?.nomeEmpresaVendas}
                    </S.CardSubtitle>
                  </div>
                  {item?.infoAusencia ? (
                    <S.RightSquareContainer>
                      <S.RightSquare>
                        <S.TextSquare>
                          <FaClock
                            color="#ffffff"
                            size={12}
                            style={{
                              marginRight: 8,
                              marginTop: 2,
                              marginLeft: 2,
                            }}
                          />
                          {item?.infoAusencia?.mensagem}
                        </S.TextSquare>
                      </S.RightSquare>
                    </S.RightSquareContainer>
                  ) : null}
                </div>
              </S.Card>

              <S.ActionsContainer>
                {item?.ativo ? (
                  <>
                    <S.Arrows>
                      <FaArrowUp
                        size={20}
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          openMove(item?.idCorretorSistemaOrigem, "1")
                        }
                      />
                      <FaArrowDown
                        size={20}
                        style={{
                          cursor: "pointer",
                          opacity: isLastItem ? 0.5 : 1,
                        }}
                        onClick={() => {
                          if (isLastItem) return;
                          openMove(item?.idCorretorSistemaOrigem, "2");
                        }}
                      />
                    </S.Arrows>
                    <S.PositionNumber>{item?.posicao}</S.PositionNumber>
                    <FaClock
                      onClick={() => {
                        if (item?.ausente === true) {
                          openReturn(item?.idCorretorSistemaOrigem);
                        } else openAusencia(item?.idCorretorSistemaOrigem);
                      }}
                      color="#F18935"
                      size={20}
                      style={{ cursor: "pointer" }}
                    />
                    <IoHandRightSharp
                      onClick={() =>
                        openBaterMao(item?.idCorretorSistemaOrigem)
                      }
                      color="#819DFF"
                      size={20}
                      style={{ cursor: "pointer" }}
                    />
                    <IoTrash
                      onClick={() => openDelete(item?.idCorretorSistemaOrigem)}
                      color="#F43636"
                      size={20}
                      style={{ cursor: "pointer" }}
                    />
                  </>
                ) : null}
              </S.ActionsContainer>
            </S.Row>
          );
        })}
      </S.ListContainer>

      <S.SpaceY space={32} />

      <CustomPagination
        count={totalPages}
        page={page}
        onPageChange={(_event, newPage) => handleChangePage(newPage)}
      />

      <ModalCommonConfirm
        icon={() => <IconsSVG.MoveOrderIcon />}
        message="Deseja alterar a Ordem da Fila?"
        open={isOpenMove}
        setOpen={setIsOpenMove}
        onConfirm={() => handleMove()}
        onCancel={() => setIsOpenMove(false)}
        isLoading={isLoadingMove}
        confirmLabel="Sim"
        cancelLabel="Cancelar"
      />
      <ModalCommonConfirm
        icon={() => <IconsSVG.ClockModalIcon />}
        message="Deseja marcar corretor como ausente?"
        open={isOpenAway}
        setOpen={setIsOpenAway}
        onConfirm={() => handleAusencia("1")}
        onCancel={() => setIsOpenAway(false)}
        isLoading={isLoadingAusencia}
        confirmLabel="Sim"
        cancelLabel="Cancelar"
      />
      <ModalCommonConfirm
        icon={() => <IconsSVG.DeleteIconModal />}
        message="Deseja excluir o corretor desta fila?"
        open={isOpenDelete}
        setOpen={setIsOpenDelete}
        onConfirm={() => handleDelete()}
        onCancel={() => setIsOpenDelete(false)}
        isLoading={isLoadingRemover}
        confirmLabel="Sim"
        cancelLabel="Cancelar"
      />
      <ModalCommonConfirm
        icon={() => <IconsSVG.ClockModalIcon />}
        message="Deseja confirmar retorno do Corretor?"
        open={isOpenReturn}
        setOpen={setIsOpenReturn}
        onConfirm={() => handleReturn("2")}
        onCancel={() => setIsOpenReturn(false)}
        confirmLabel="Sim"
        cancelLabel="Cancelar"
      />
      <ModalCommonOpt
        icon={() => <IconsSVG.BaterMaoModalIcon />}
        title="Bater Mão"
        open={isOpenBaterMao}
        setOpen={setIsOpenBaterMao}
        isCorretor={false}
        idRoletaCheckin={dataListarFila?.idRoletaCheckin}
        idCorretorSistemaOrigemAtual={idCorretorSistemaOrigem}
        isAdicionarCorretor={false}
        refetchListarFila={refetchListarFila}
      />
    </S.Content>
  );
};

export default TabelaFila;
